/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';
import DialogContainer from '../../../../../components/shared/Dialog/DialogContainer';
import { toast } from 'react-toastify';
import PersonnelForm from './personnelForm';
import { createPersonnelUser } from '../../../../../services/personnel/personnelController';

const PersonnelCreation = () => {
    const [open, setOpen] = useState(false);

    // Handle open/close dialog
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);



    // Handle form submission
    const handleSubmit = async (values) => {
        try {
            await createPersonnelUser(values);
            toast.success('user was created successfully');

            handleClose();

        } catch (error) {
            toast.error(error?.response?.data?.error?.message);

            handleClose();

        }
    };
    return (
        <>
            <Button variant="contained"  color="primary" style={{ float: 'right' }} onClick={handleOpen}>Create user</Button>
            {/* Dialog for Adding MApping */}
            <DialogContainer
                open={open}
                handleClose={handleClose}
            >
                <Box sx={{ mt: 2 }}>
                    <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>User Creation</Typography>

                    <Formik
                        initialValues={{
                            "getchkdid": "",
                            "username": "",
                            "secret": "",

                        }}
                        validationSchema={Yup.object().shape({
                            getchkdid: Yup.string().required('GetChkd ID is required.'),
                            username: Yup.string().required('User name  is required.'),
                            secret: Yup.string().required('Secret is required.'),
                        })}
                        onSubmit={(
                            values
                        ) => {
                            handleSubmit(values)
                        }
                        }
                    >
                        {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                            <PersonnelForm
                                values={values}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                isSubmitting={isSubmitting}
                                handleClose={handleClose}
                                errors={errors}
                                touched={touched} />)}
                    </Formik>
                </Box>

            </DialogContainer>
        </>
    )

}

export default PersonnelCreation;
